export class Achievement {

    public key: string = null;
    public title: string = null;
    public text: string = null;
    public quote: string = null;
    public author: string = null;
    public icon: string = null;
    public displayed: boolean = false;
    public isAchieved: Function = null;
    public checked: boolean = false;

    constructor(key: string, json: any = null, fn: Function) {
        this.key = key;
        this.isAchieved = fn;
        if(json) this.updateFromJson(json);
    }

    public updateFromJson(json: any) {
        this.title = json.title || "Achievement";
        this.text = json.text || "Lucky you!";
        this.icon = json.icon || "";
        this.quote = json.quote || "";
        this.author = json.author || "";
    }

    public toJson() {
        return {
            title: this.title,
            text: this.text,
            quote: this.quote,
            icon: this.icon,
            author: this.author
        }
    }
}
